import { getSelectorRoot } from 'utils/selectors';

const getGameData = getSelectorRoot('gameData');

export const getGameInfo = getGameData('gameData');
